import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    output,
} from '@angular/core';
import { QpxHeroIcon, QpxButton, QpxTypography } from '@quipex/shared/ui';
import { resolveColorContext } from '@quipex/shared/utils';
import type { QuippyAssistantAppearance } from '../../../runtime';
import type { QuippyOutcome } from '../outcome-selection';

@Component({
    selector: 'qpx-quippy-outcome-cards',
    imports: [QpxButton, QpxTypography, QpxHeroIcon],
    templateUrl: './outcome-cards.html',
    styleUrl: './outcome-cards.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        role: 'group',
        'aria-label': 'Quippy actions',
    },
})
export class QuippyOutcomeCards {
    public readonly scopeKind = input.required<'building' | 'portfolio'>();
    public readonly packAvailable = input.required<boolean>();
    public readonly selected = input.required<QuippyOutcome>();
    public readonly appearance = input.required<QuippyAssistantAppearance>();
    public readonly disabled = input(false);
    public readonly headingId = input.required<string>();
    public readonly outcomeSelected = output<QuippyOutcome>();

    protected readonly cards = computed(() =>
        [
            {
                id: 'ask' as const,
                title: 'Ask a question',
                description:
                    this.scopeKind() === 'building'
                        ? 'Understand your building'
                        : 'Understand your portfolio',
                icon: 'lucideLightbulb',
                context: 'primary' as const,
            },
            {
                id: 'find' as const,
                title: 'Find documents',
                description: 'Search files and records',
                icon: 'lucideFolder',
                context: 'info' as const,
            },
            ...(this.packAvailable()
                ? [
                      {
                          id: 'pack' as const,
                          title: 'Create a pack',
                          description: 'Organise useful documents',
                          icon: 'lucideNotebookTabs',
                          context: 'success' as const,
                      },
                  ]
                : []),
        ].map((card) => ({
            ...card,
            colors: resolveColorContext(card.context, 'muted'),
        }))
    );
}
